// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"474":"8b402578647da961","9859":"88f96a9b352c3bdb"}[chunkId] + ".css";
};